import * as React from "react";
import { IText } from "../../classes/text";

export interface IFooterSectionProps {
    text: IText;
  }

  export const FooterSection = (props: IFooterSectionProps) => {

    return (
      <div className="CAL-timeAlert">{props.text.userTimezoneInfo}</div>
    );
  };
